import React from 'react';

import HourglassFullTwoToneIcon from '@mui/icons-material/HourglassFullTwoTone';
import HourglassEmptyTwoToneIcon from '@mui/icons-material/HourglassEmptyTwoTone';

import StoreTwoToneIcon from '@mui/icons-material/StoreTwoTone';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';

import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import BusinessCenterTwoToneIcon from '@mui/icons-material/BusinessCenterTwoTone';

import BusinessTwoToneIcon from '@mui/icons-material/BusinessTwoTone';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { PersonRounded, VisibilityRounded, VpnKeyRounded, PublicRounded } from '@mui/icons-material';

export const drawerWidth = 230;

export const options = [
  { message: 'Basic', value: 'view', icon: <VisibilityRounded /> },
  { message: 'Standard', value: 'standard', icon: <PersonRounded /> },
  { message: 'Admin', value: 'admin', icon: <VpnKeyRounded /> },
  { message: 'Portal', value: 'portal', icon: <PublicRounded /> },
];

export const getDiscountDecimal = (discount) => {
  return (100 - discount) / 100;
};

export const getOriginalDecimal = (discount) => {
  return (100 + discount) / 100;
};

const iconStyles = {
  width: 64,
  height: 64,
};

export const trialPackage = {
  name: 'Trial',
  icon: 'trial',
  isFree: true,
  pricePerMonth: 0,
  pricePerAnnum: 0,
  enabled: true,
  users: 5,
};

export const icons = (styles = {}) => [
  {
    name: 'trial',
    icon: <HourglassEmptyTwoToneIcon style={{ ...iconStyles, color: 'lightgrey', ...styles }} />,
    selectedIcon: <HourglassFullTwoToneIcon style={{ ...iconStyles, color: 'green' }} />,
  },
  {
    name: 'business',
    icon: <BusinessCenterOutlinedIcon style={iconStyles} />,
    selectedIcon: <BusinessCenterTwoToneIcon style={{ ...iconStyles, color: 'green', ...styles }} />,
  },
  {
    name: 'store',
    icon: <StoreOutlinedIcon style={{ ...iconStyles, color: 'lightgrey' }} />,
    selectedIcon: <StoreTwoToneIcon style={{ ...iconStyles, color: 'green', ...styles }} />,
  },
  {
    name: 'businessoutline',
    icon: <BusinessOutlinedIcon style={{ ...iconStyles, color: 'lightgrey' }} />,
    selectedIcon: <BusinessTwoToneIcon style={{ ...iconStyles, color: 'green', ...styles }} />,
  },
];

export const icon = (icon, styles = {}) => icons(styles).find((i) => i.name === icon);

export const emailCategories = [
  {
    label: 'Standard Notification',
    value: '/notifications/index.ejs',
  },
  {
    label: 'Form Entry',
    value: '/forms/invitation.ejs',
  },
  {
    label: 'General',
    value: 'general',
  },
];
